import { Snackbar } from '@didomi/utility';

const CONNECTING_ID = 'oauth-ui-connecting';
const CONNECTED_ID = 'oauth-ui-connected';

/** Imperative snackbar for connect flow — avoids React + Stencil DOM conflicts. */
export async function showConnectingSnackbar(): Promise<() => void> {
  const { close } = await Snackbar.displaySnackbar('Connecting…', {
    id: CONNECTING_ID,
    permanent: true,
  });
  return close;
}

/** Replaces the connecting snackbar (do not call `close` on the previous snackbar first — utility handles handoff). */
export async function showConnectedSnackbar(): Promise<void> {
  await Snackbar.displaySnackbar('Connected. Closing…', {
    id: CONNECTED_ID,
    icon: 'check',
    duration: 8000,
  });
}
